import React, {
  useEffect,
  useMemo,
} from 'react';

import {
  RecordContextProvider,
} from 'react-admin';

import {
  Box,
  Slide,
} from '@mui/material';

import {
  Route,
  Routes,
  useSearchParams,
} from 'react-router-dom';

import { EntityTypes } from '../../constants/entityTypes';
import conflictFields, { ConflictFields } from '../../constants/conflictFields';
import ConflictResolutionHistory from './ConflictResolutionHistory';
import ConflictResolutionManualInput from './ConflictResolutionManualInput';
import ConflictMarkAsVerified from './ConflictMarkAsVerified';
import ConflictValueListView from './ConflictValueListView';

const isValidDatapointName = (
  name?: string,
): name is ConflictFields => !!name && (Object.values(conflictFields) as string[]).includes(name);

const ConflictResolution = ({
  entityId,
  entityType,
  hideBackButton = false,
  customValueActions,
}: {
  entityId: string;
  entityType: EntityTypes;
  hideBackButton?: boolean;
  customValueActions?: React.ReactNode;
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [searchParams] = useSearchParams();
  const name = searchParams.get('name');
  const info = searchParams.get('identificationInfo');
  const identificationInfo = info ? JSON.parse(info) : undefined;

  const conflictContext = useMemo(() => {
    if (!name) return null;
    if (!isValidDatapointName(name)) return null;

    return {
      name,
      entityId,
      entityType,
      identificationInfo,
    };
  }, [identificationInfo, name, entityId, entityType]);

  if (!conflictContext) return null;

  return (
    <Slide appear={!hideBackButton} in direction="left">
      <Box>
        <RecordContextProvider value={conflictContext}>
          <Routes>
            <Route
              index
              element={(
                <ConflictValueListView
                  hideBackButton={hideBackButton}
                  customValueActions={customValueActions}
                />
              )}
            />
            <Route
              path="manual-input"
              element={<ConflictResolutionManualInput />}
            />
            <Route
              path="history"
              element={<ConflictResolutionHistory />}
            />
            <Route
              path="mark-verified/:valueId"
              element={<ConflictMarkAsVerified />}
            />
          </Routes>
        </RecordContextProvider>
      </Box>
    </Slide>
  );
};

export default ConflictResolution;
